import styled from 'styled-components';

export const TimelineContainer = styled.div`
  font-family: 'Arial', sans-serif;
  background-color: #f2f2f2;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  text-align: left;
  height: 100%;
`;

export const Timeline = styled.div`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    margin-bottom: 4px;
    left: 22px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(
      to bottom,
      #9000ff ${props => props.timelineColor}%,
      #c5c5c5 ${props => 1 - props.timelineColor}%,
      #c5c5c5 100%
    );
  }
`;

export const TimelineContent = styled.div`
  margin-left: 50px;
  margin-top: -10px;
`;

export const TimelineItem = styled.div`
  margin-top: 52px;
  padding-left: 20px;
  background-color: #f2f2f2;
`;

export const TimelineIcon = styled.div`
  position: absolute;
  left: 0;
  height: 30px;
  width:46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-top:7px
  background-color: #f2f2f2;
`;

export const Title = styled.div`
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
`;

export const DescriptionStep = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
  color: #333;
`;

export const Notification = styled.div`
  margin-top: 20px;
  background-color: #e9ecef;
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
`;

export const NotificationIcon = styled.div`
  size: 5px;
`;
